import React from "react";
import { Link } from "react-router-dom";
import { Store } from "lucide-react";
import { APP_CONFIG, normalizeBrandLogoUrl, normalizeBrandName } from "@/config/appConfig";

export default function Logo({ size = "md", to = "/", className = "", name = APP_CONFIG.brandName, logoUrl = "" }) {
  const dims = size === "sm" ? "h-7 w-7" : size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const pixels = size === "sm" ? 28 : size === "lg" ? 44 : 36;
  const text = size === "sm" ? "text-sm sm:text-base" : size === "lg" ? "text-lg sm:text-2xl" : "text-base sm:text-xl";
  const displayName = normalizeBrandName(name);
  const displayLogoUrl = normalizeBrandLogoUrl(logoUrl);
  const isDefaultBrand = !displayLogoUrl && displayName === APP_CONFIG.brandName;
  return (
    <Link
      to={to}
      data-testid="brand-logo"
      className={`inline-flex items-center gap-2.5 group ${className}`}
    >
      {displayLogoUrl ? <img src={displayLogoUrl} alt="" width={pixels} height={pixels} className={`${dims} rounded-xl object-cover shadow-glow`} /> : isDefaultBrand ? (
        <div className={`${dims} overflow-hidden rounded-xl bg-[#0b1220] shadow-glow flex-shrink-0`}>
          <img src={APP_CONFIG.brandAssets.icon192} alt="" width={pixels} height={pixels} className="h-full w-full scale-[1.35] object-cover object-top" data-testid="brand-icon" />
        </div>
      ) : (
        <div className={`${dims} rounded-xl bg-gradient-to-br from-indigo-500 to-fuchsia-500 grid place-items-center shadow-glow`}>
          <Store className="h-4 w-4 text-white" strokeWidth={2.4} />
        </div>
      )}
      {isDefaultBrand ? <span className={`font-display font-semibold tracking-tight ${text} whitespace-nowrap bg-gradient-to-r from-blue-500 via-orange-500 to-green-500 bg-clip-text text-transparent`} aria-label={APP_CONFIG.brandLabel}>{APP_CONFIG.brandName}</span> : <span className={`font-display font-semibold tracking-tight ${text} text-ink-primary`}>{displayName}</span>}
    </Link>
  );
}
